<template>
    <div>
        <vs-row>
            <!-- Other columns -->
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input :value="data_obj.data.id ? `Entry #${data_obj.data.id}` : 'Auto Generated'" label="* Issue ID"
                    readonly class="w-full" />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign :model="data_obj.added_by" label="Added By" placeholder="Auto Filled" :multiple="false"
                    :load_initial="false" :label_keys="['first_name', 'last_name']" :show_id_in_label="true"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                    container_class="w-full" input_class="" :use_id_as_value="false" :disabled="true" />
                <small class="block text-danger mt-1" v-if="api_errors.added_by">
                    {{ api_errors.added_by.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectDate class="w-full" :selectedDate.sync="data_obj.date" label="Date *" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.date">
                    {{ api_errors.date.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign :model.sync="data_obj.data.type_of_road" label="Type Of Road"
                    placeholder="Type to Search..." :multiple="false" :load_initial="true" :label_keys="['name',]"
                    :show_id_in_label="false" :endpoint="`${$store.state.apiendpoints.data_type_of_roads}?active=true`"
                    container_class="w-full" input_class="" :use_id_as_value="false" :disabled="mode != 'e'"
                    :use_cache="true" />
                <small class="block text-danger mt-1" v-if="api_errors.type_of_road">
                    {{ api_errors.type_of_road.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="4" class="mb-3">
                <label class="vs-input--label block">Side</label>
                <div class="flex mt-3 align-center">
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side"
                        vs-value="lhs">LHS</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side" vs-value="rhs"
                        class="mx-3">RHS</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side" vs-value="junctions"
                        class="mx-3">Junctions</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side" vs-value="median"
                        class="mx-3">Median</vs-radio>
                </div>
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.side">
                    {{ api_errors.data.side.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="4" class="mb-3">
                <label class="vs-input--label block">Chainage</label>
                <vs-row class="mt-1">
                    <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-0 pr-1">
                        <div class="flex" style="align-items: center">
                            <label class="vs-input--label block mr-3">From</label>
                            <vs-input v-model="data_obj.data.chainage_from" class="w-full" :disabled="mode != 'e'"
                                type="Number" />
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_from">
                            {{ api_errors.data.chainage_from.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-1 pr-0">
                        <div class="flex" style="align-items: center">
                            <label class="vs-input--label block mr-3">To</label>
                            <vs-input v-model="data_obj.data.chainage_to" class="w-full" :disabled="mode != 'e'"
                                type="Number" />
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_to">
                            {{ api_errors.data.chainage_to.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input v-model="data_obj.data.length" label="Length (mts)" class="w-full" type="Number" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.length">
                    {{ api_errors.data.length.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                <label class="vs-input--label block">Quantity</label>
                <vs-row class="mt-1">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1">
                        <vs-input v-model="data_obj.data.no_of_strips" class="w-auto" :disabled="mode != 'e'"
                            type="Number" />
                        <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.no_of_strips">
                            {{ api_errors.data.no_of_strips.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input v-model="data_obj.data.effective_length" label="Effective length (sq mts)" class="w-full"
                    type="Number" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.effective_length">
                    {{ api_errors.data.effective_length.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input v-model="data_obj.data.width" label="Width (sq mts)" class="w-full" type="Number"
                    :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.width">
                    {{ api_errors.data.width.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input v-model="data_obj.data.per_day_progress" label="Per Day Progress" class="w-full"
                    type="Number" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.per_day_progress">
                    {{ api_errors.data.per_day_progress.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input v-model="data_obj.data.per_day_progress_metres" label="Per Day Progress (sq mts)"
                    class="w-full" type="Number" readonly />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.per_day_progress_metres">
                    {{ api_errors.data.per_day_progress_metres.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-select v-model="data_obj.data.description_of_work" label="Description of Work" class="w-full" autocomplete>
                    <vs-select-item v-for="(item, index) in descriptionOfWorkOptions" :key="index" :value="item"
                        :text="item" />
                </vs-select>
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.description_of_work">
                    {{ api_errors.data.description_of_work.join(', ') }}
                </small>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    <label class="vs-input--label block mb-1">Remarks</label>
                    <vs-textarea v-model="data_obj.data.remarks" :disabled="mode != 'e'" />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.remarks">
                        {{ api_errors.data.remarks.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1">Images</label>
                    <FileSelection :images.sync="data_obj.images"
                        :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                        :read_only="mode != 'e'" />
                </vs-col>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="px-0">
                <LocationChooser :disabled="mode != 'e'" :latitude.sync="data_obj.data.location_latitude"
                    :longitude.sync="data_obj.data.location_longitude"
                    :api_errors="{ latitude: api_errors.data ? api_errors.data.location_latitude : null, longitude: api_errors.data ? api_errors.data.location_longitude : null }" />
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import FileSelection from "../../../Issue/Components/FileSelection.vue"
import LocationChooser from "../../../Issue/Components/LocationChooser.vue"

export default {
    props: {
        data: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        }
    },
    components: {
        FileSelection,
        LocationChooser
    },
    data() {
        return {
            data_obj: this.data,
            descriptionOfWorkOptions: [
                "Road Marking, Inner Edge Line",
                "Road Marking, Shoulder Line",
                "Road Marking, Shoulder Line Dotted",
                "Road Marking, Inner Edge Line Dotted",
                "Road Marking, Zebra Crossing",
                "Road Marking, Approach road edge line",
                "Road Marking, Island edge line",
                "Road Marking, Approach road center line",
                "Road Marking, Other",
                "Road Marking, Center line (6 meter)",
                "Road Marking, Center line (3 meter)"
            ],
            default_data: {
                chainage_from: null,
                chainage_to: null,
                remarks: null,
                side: null,
                length: null,
                no_of_strips: null,
                effective_length: null,
                width: null,
                per_day_progress_metres: null,
                per_day_progress: null,
                location_latitude: null,
                location_longitude: null,
                type_of_road: null,
                description_of_work: null
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_data_obj(newV)
            }
        },
        data_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:data', newV)
            }
        },
        'data_obj.data.no_of_strips'() {
            this.update_per_day_progress()
        },
        'data_obj.data.length'() {
            this.update_per_day_progress()
        },
        'data_obj.data.width'() {
            this.update_per_day_progress()
        }
    },
    mounted() {
        this.update_data_obj(this.data)
    },
    methods: {
        update_data_obj(new_data) {
            if (!new_data) this.data_obj = null
            else {
                let data_obj = { ...new_data }
                if (!data_obj.data || Object.keys(data_obj.data).length == 0)
                    data_obj.data = this.deepclone(this.default_data)

                if (data_obj.data.effective_length === "") {
                    data_obj.data.effective_length = null
                }
                if (data_obj.data.per_day_progress === "") {
                    data_obj.data.per_day_progress = null
                }

                this.data_obj = data_obj
            }
        },
        update_per_day_progress() {
            let no_of_strips = this.data_obj.data.no_of_strips || 0
            let length = this.data_obj.data.length || 0
            let width = this.data_obj.data.width || 0

            if (no_of_strips && length && width) {
                let progress = parseFloat((parseFloat(no_of_strips) * parseFloat(length) * parseFloat(width)).toFixed(3))
                this.$set(this.data_obj.data, 'per_day_progress_metres', progress)
            } else {
                this.$set(this.data_obj.data, 'per_day_progress_metres', 0)
            }
        }
    }
}
</script>